var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1625 5.58097H16.4649C16.0072 5.58097 15.6277 5.20144 15.6277 4.74376C15.6277 4.28609 16.0072 3.90656 16.4649 3.90656H23.1625C23.6202 3.90656 23.9997 4.28609 23.9997 4.74376C23.9997 5.20144 23.6202 5.58097 23.1625 5.58097Z",
    fill: "#178477"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30233 5.58097H0.837209C0.379535 5.58097 0 5.20144 0 4.74376C0 4.28609 0.379535 3.90656 0.837209 3.90656H5.30233C5.76 3.90656 6.13953 4.28609 6.13953 4.74376C6.13953 5.20144 5.76 5.58097 5.30233 5.58097Z",
    fill: "#178477"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76732 9.48837C7.15523 9.48837 5.02313 7.35628 5.02313 4.74419C5.02313 2.13209 7.15523 0 9.76732 0C12.3794 0 14.5115 2.13209 14.5115 4.74419C14.5115 7.35628 12.3794 9.48837 9.76732 9.48837ZM9.76732 1.67442C8.07057 1.67442 6.69755 3.04744 6.69755 4.74419C6.69755 6.44093 8.07057 7.81395 9.76732 7.81395C11.4641 7.81395 12.8371 6.44093 12.8371 4.74419C12.8371 3.04744 11.4641 1.67442 9.76732 1.67442Z",
    fill: "#178477"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1631 17.8604H18.698C18.2403 17.8604 17.8608 17.4808 17.8608 17.0232C17.8608 16.5655 18.2403 16.1859 18.698 16.1859H23.1631C23.6208 16.1859 24.0003 16.5655 24.0003 17.0232C24.0003 17.4808 23.6208 17.8604 23.1631 17.8604Z",
    fill: "#178477"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53488 17.8604H0.837209C0.379535 17.8604 0 17.4808 0 17.0232C0 16.5655 0.379535 16.1859 0.837209 16.1859H7.53488C7.99256 16.1859 8.37209 16.5655 8.37209 17.0232C8.37209 17.4808 7.99256 17.8604 7.53488 17.8604Z",
    fill: "#178477"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2336 21.7678C11.6215 21.7678 9.48938 19.6357 9.48938 17.0236C9.48938 14.4115 11.6215 12.2794 14.2336 12.2794C16.8457 12.2794 18.9778 14.4115 18.9778 17.0236C18.9778 19.6357 16.8457 21.7678 14.2336 21.7678ZM14.2336 13.9538C12.5368 13.9538 11.1638 15.3268 11.1638 17.0236C11.1638 18.7203 12.5368 20.0933 14.2336 20.0933C15.9303 20.0933 17.3033 18.7203 17.3033 17.0236C17.3033 15.3268 15.9303 13.9538 14.2336 13.9538Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.71130f14f0a834819769daee514f70ca.svg";
export { ForwardRef as ReactComponent };